<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="添加工程"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>
		<div style="height: 56px;"></div>
		<van-cell-group style="margin-bottom: 15px;">
			<van-field
				clearable
				required
				v-model="form.projectName"
				label="工程名称"
				placeholder="工程名称"
			/>
			<van-field
				clearable
				required
				v-model="form.projectAddress"
				label="工程地址"
				placeholder="工程地址"
			/>
			<van-field
				clearable
				required
				v-model="form.projectCompany"
				label="施工公司"
				placeholder="施工公司"
			/>
		</van-cell-group>
		<van-cell-group>
			<div class="form-upload">
				<div class="form-upload-head">
					<div class="form-upload-title">照片附件</div>
					<div class="form-upload-desc">可以上传工地照片、中标公告、协议合同等可证明工程真实存在的文件。</div>
				</div>
				<van-uploader v-model="projectPicFile" :after-read="afterRead" />
			</div>
		</van-cell-group>
		<div style=" padding: 32px 16px 0 16px;">
		    <van-button round block type="primary" color="#2f86f6" :disabled="submitLoading" :loading="submitLoading" @click="onSubmit">提 交</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'title_add',
		data() {
			return {
				form : {},
				projectPicFile : [],
				submitLoading : false
			}
		},
		mounted() {
		},
		methods: {

			onSubmit(){
				
				const projectPicVal = this.getArrUrls( this.projectPicFile);
				if( projectPicVal.isUpload){
				    this.$toast('图片上传中，请稍等...');
				    return false;
				}
				
				if( !this.form.projectName ){
					this.$toast('请输入工程名称');
					return false;
				}
				if( !this.form.projectAddress ){
					this.$toast('请输入工程地址');
					return false;
				}
				if( !this.form.projectCompany ){
					this.$toast('请输入施工公司');
					return false;
				}
				this.form.projectPics = projectPicVal.urls;
				
				this.submitLoading = true;
				this.$post('/gtb/home/addInvoiceProject.html', this.form ).then(res=>{
					this.submitLoading = false;
					if( res.success ){
						this.$toast.success(res.msg);
						this.$router.go(-1);
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch((res) => {
					this.submitLoading = false;
				});
				
			},
			//上传图片
			afterRead(file) {
				file.status = 'uploading';
				file.message = '上传中...';
				this.$upload({ file : file.file , dir : 'project' }).then(url=>{
					file.status = 'done';
					file.message = '上传成功'
					file.url = url;
				}).catch(error=>{
					file.status = 'failed';
					file.message = '上传失败';
				})
			},
			getArrUrls(arr){
				let urls = [];
				for( let i = 0; i < arr.length; i++ ){
				    const item = arr[i];
				    if( item.status === 'done'){
				        urls.push(item.url);
				    }
				    if( item.status === 'uploading'){
				        return { isUpload : true }
				    }
				}
				return {
				    isUpload : false,
				    urls : urls
				};
			},
		},
		
	}
</script>
<style scoped>
	.form-upload{padding: 16px;}
	.form-upload-head{margin-bottom: 15px;}
	.form-upload-title{margin-bottom: 5px;}
	.form-upload-desc {font-size: 12px;color: #999;}
</style>